export default [{
  path: '/onboarded-applicants/licensed-candidates',
  name: 'LicensedCandidates',
  meta: {
    title: 'Licensed Candidates'
  },
  component: function () {
    return import( /* webpackChunkName: "support" */ '../modules/onboarded-applicants/views/LicensedCandidates.vue')
  },
}]